module.exports = __webpack_public_path__ + "roboto-mediumitalic-webfont.bbee79e7ac0b931c1b46.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-mediumitalic-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-mediumitalic-webfont.svg
// module chunks = styles